"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_BUNDLE_INFO = void 0;
var graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.UPDATE_BUNDLE_INFO = (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation UpdateBundleInfo($input: BundleInfoInput!) {\n    addUpdateBundleInfo(input: $input) {\n      name\n      gender\n      birthMonth\n      birthYear\n    }\n  }\n"], ["\n  mutation UpdateBundleInfo($input: BundleInfoInput!) {\n    addUpdateBundleInfo(input: $input) {\n      name\n      gender\n      birthMonth\n      birthYear\n    }\n  }\n"])));
var templateObject_1;
